import ScrollTop from "./scrolltop.component.vue";

export default ScrollTop;
